<div class="modal-header header-fancy">
    <div>
        <h5 class="modal-title fw-semibold">Attach Card (Stripe)</h5>
        <div class="small text-muted" *ngIf="patientName">
            <h6>Patient: <b>{{ patientName }}</b></h6>
        </div>
    </div>

    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body body-fancy">
    <div class="tip">
        <div class="fw-semibold">Test Mode Tip</div>
        <div class="small muted">
            Use test card:
            <b>4242 4242 4242 4242</b> — Exp: <b>12/34</b> — CVC: <b>123</b>
        </div>
    </div>

    <div class="grid-2">
        <!-- LEFT -->
        <div class="panel-left">
            <div class="section-title">
                <div class="dot"></div>
                <div>
                    <div class="t1">Card Details</div>
                    <div class="t2">Securely captured by Stripe Elements</div>
                </div>
            </div>

            <div class="stripe-box">
                <div id="card-element"></div>
            </div>

            <div class="text-danger small mt-2" *ngIf="cardError">{{ cardError }}</div>

            <div class="small muted mt-2" *ngIf="!cardError">
                Card data is handled by Stripe securely. Backend will only store <code>pm_...</code>.
            </div>

            <div class="divider"></div>

            <!-- ✅ Only one field -->
            <div class="section-title">
                <div class="dot"></div>
                <div>
                    <div class="t1">Card Holder</div>
                    <div class="t2">This will show on the mock card</div>
                </div>
            </div>

            <div class="form-grid one">
                <div class="field">
                    <label class="lbl">Card Holder Name</label>
                    <input class="inp" type="text" [(ngModel)]="cardName" placeholder="e.g. John Smith" />
                </div>
            </div>

            <div class="d-flex align-items-center gap-2 mt-3 check-row">
                <input id="def" type="checkbox" [(ngModel)]="setAsDefault" />
                <label for="def" class="small mb-0">Set as default card</label>
            </div>
        </div>

        <!-- RIGHT -->
        <div class="panel-right">
            <div class="preview-head">
                <div class="badge text-success">
                    <span class="pulse"></span>
                    Live Preview
                </div>
                <div class="small muted">Mock card updates from Stripe</div>
            </div>

            <div class="card-shell" [class.is-default]="setAsDefault">
                <div class="card-glow"></div>
                <div class="card-shine"></div>

                <!-- ✅ chip on top-right -->
                <div class="card-top">
                    <div class="brand">
                        <span class="brand-t">{{ brand || "CARD" }}</span>
                    </div>
                    <div class="chip chip-right">
                        <img src="https://png.pngtree.com/png-vector/20231223/ourmid/pngtree-credit-card-chip-shopping-png-image_11198229.png"
                            class="img-fluid" />
                    </div>
                </div>

                <!-- ✅ number + expiry + cvc -->
                <div class="card-number">
                    •••• •••• •••• {{ safeLast4 }}
                </div>

                <div class="card-mini-row">
                    <div class="mini">
                        <div class="k">EXP</div>
                        <div class="v">{{ safeExpiry }}</div>
                    </div>
                    <div class="mini">
                        <div class="k">CVC</div>
                        <div class="v">{{ safeCvc }}</div>
                    </div>
                </div>

                <div class="card-row single">
                    <div class="kv">
                        <div class="k">Card Holder</div>
                        <div class="v">{{ cardName || "YOUR NAME" }}</div>
                    </div>
                </div>

                <div class="card-footer">
                    <div class="small muted2">{{ setAsDefault ? "Default Card" : "Not Default" }}</div>
                    <div class="secure">
                        <span class="lock"></span>
                        Secure
                    </div>
                </div>
            </div>

            <div class="hint small muted mt-3">
                Card number/expiry appear after Stripe validates (and definitely after Attach).
                CVC is always masked for security.
            </div>
        </div>
    </div>
</div>

<div class="modal-footer footer-fancy">
    <button class="btn btn-outline-secondary btn-sm" (click)="activeModal.dismiss()" [disabled]="loading">
        Cancel
    </button>

    <button class="btn btn-primary btn-sm btn-glow" (click)="attach()" [disabled]="loading || !cardComplete">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        Attach Card
    </button>
</div>